import moment from 'moment';
import { API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_SUCCESS, API_GET_ONE_PROFFIT_SEARCH_SHARE_RECEIVE_SUCCESS, API_UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE, } from '../actions/ProffitSearchReceiveAction';
// eslint-disable-next-line default-param-last
export default (state = {}, { meta, payload, type }) => {
    switch (type) {
        case API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_SUCCESS: {
            const addObj = {};
            payload.list.forEach((v) => {
                addObj[v.id] = v;
            });
            return Object.assign(Object.assign({}, state), addObj);
        }
        case API_GET_ONE_PROFFIT_SEARCH_SHARE_RECEIVE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { [meta.id]: payload });
        }
        case API_UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE: {
            return Object.assign(Object.assign({}, state), { [meta.id]: Object.assign(Object.assign({}, (state[meta.id] || {})), { receivedAt: moment().format('YYYY-MM-DD HH:mm:ss') }) });
        }
        default: {
            return state;
        }
    }
};
